(function () {
  'use strict';

  if (!document.body || !document.body.classList.contains('template-cart')) {
    return;
  }

  var validationSelector = '#wk_minimum_purchase_div';
  var refreshTimer = null;
  var failsafeTimer = null;
  var fetchWrapped = false;
  var isDecorating = false;
  var webkulWaitAttempts = 0;

  function getValidationEl() {
    return document.querySelector(validationSelector);
  }

  function isWebkulReady() {
    return (
      window.SPL &&
      typeof window.SPL.checkMinimumPurchase === 'function' &&
      window.SPL.$
    );
  }

  function resetWebkulState() {
    var validationEl = getValidationEl();

    document
      .querySelectorAll('#wk_min_qty_error, [id^="wk_min_qty_error"]')
      .forEach(function (el) {
        el.remove();
      });

    document.querySelectorAll('.wk_qty_selector').forEach(function (input) {
      input.style.color = '';
      input.style.backgroundColor = '';
    });

    if (!validationEl) {
      return;
    }

    validationEl.innerHTML = '';
    validationEl.removeAttribute('data-fail');
    validationEl.classList.remove('is-fail', 'is-pass', 'is-expanded');
  }

  function showLoadingState() {
    var validationEl = getValidationEl();

    if (!validationEl) {
      return;
    }

    validationEl.style.display = 'block';
    validationEl.classList.add('is-refreshing');
    validationEl.innerHTML =
      '<div class="cart-checkout-validation__loading">Memperbarui syarat checkout...</div>';
  }

  function formatRupiahText(root) {
    var textEls = root.querySelectorAll('td, .wk_fail, .wk_success');

    textEls.forEach(function (el) {
      var newText = el.textContent
        .replace(/Rp\s?(\d{4,})(?![.,]\d)/g, function (_, amount) {
          var numericAmount = Number(amount);

          if (!Number.isFinite(numericAmount)) {
            return 'Rp ' + amount;
          }

          return 'Rp ' + new Intl.NumberFormat('id-ID').format(numericAmount);
        })
        .replace(/Rp(\d)/g, 'Rp $1');

      if (newText !== el.textContent) {
        el.textContent = newText;
      }
    });
  }

  function extractValidationRows(validationEl) {
    var table = validationEl.querySelector('.wk_minimum_purchase_table');

    if (!table) {
      return [];
    }

    return Array.prototype.slice.call(table.querySelectorAll('tbody tr')).map(function (row) {
      var cells = Array.prototype.slice.call(row.querySelectorAll('td'));

      return {
        store: cells[0] ? cells[0].textContent.trim() : '',
        product: cells[1] ? cells[1].textContent.trim() : '',
        status: cells[2] ? cells[2].textContent.trim() : '',
        failed: Boolean(row.querySelector('.wk_fail')),
      };
    });
  }

  function resolveValidationDescription(rows, hasFailedRow) {
    if (!hasFailedRow) {
      return 'Pesanan sudah memenuhi minimum pembelian per toko.';
    }

    var failedRows = rows.filter(function (row) {
      return row.failed;
    });
    var firstFailed = failedRows[0];

    if (!firstFailed) {
      return 'Tambahkan produk sesuai minimum pembelian sebelum checkout.';
    }

    return firstFailed.status || 'Tambahkan produk sesuai minimum pembelian sebelum checkout.';
  }

  function renderCompactValidation(validationEl, hasFailedRow) {
    var previousSummary = validationEl.querySelector('.cart-checkout-validation__summary');
    var rows = extractValidationRows(validationEl);
    var table = validationEl.querySelector('.wk_minimum_purchase_table');
    var failedCount = rows.filter(function (row) {
      return row.failed;
    }).length;
    var expanded = validationEl.classList.contains('is-expanded');
    var detailId = 'cart-checkout-validation-details';
    var title = hasFailedRow ? 'Belum bisa checkout' : 'Syarat checkout terpenuhi';
    var description = resolveValidationDescription(rows, hasFailedRow);
    var summary = document.createElement('div');

    if (previousSummary) {
      previousSummary.remove();
    }

    summary.className = 'cart-checkout-validation__summary';
    summary.innerHTML =
      '<span class="cart-checkout-validation__icon" aria-hidden="true"></span>' +
      '<span class="cart-checkout-validation__copy">' +
      '<strong>' +
      title +
      '</strong>' +
      '<small>' +
      description +
      '</small>' +
      '</span>' +
      (rows.length
        ? '<button type="button" class="cart-checkout-validation__detail" data-checkout-validation-toggle aria-expanded="' +
          (expanded ? 'true' : 'false') +
          '" aria-controls="' +
          detailId +
          '">' +
          (expanded ? 'Tutup detail' : failedCount > 1 ? 'Lihat ' + failedCount + ' kendala' : 'Lihat detail') +
          '</button>'
        : '');

    if (table) {
      table.id = detailId;
      table.classList.add('cart-checkout-validation__details');
      table.hidden = !expanded;
      validationEl.insertBefore(summary, table);
    } else {
      validationEl.insertBefore(summary, validationEl.firstChild);
    }
  }

  function decorateValidation() {
    var validationEl = getValidationEl();

    if (!validationEl || isDecorating) {
      return;
    }

    isDecorating = true;

    try {
      validationEl.classList.remove('is-refreshing');

      if (validationEl.querySelector('.cart-checkout-validation__loading')) {
        validationEl.innerHTML = '';
      }

      if (!validationEl.textContent.trim()) {
        validationEl.style.display = 'none';
        validationEl.classList.remove('is-fail', 'is-pass');
        return;
      }

      formatRupiahText(validationEl);

      var hasFailedRow =
        validationEl.getAttribute('data-fail') === 'true' ||
        Boolean(validationEl.querySelector('.wk_fail'));

      validationEl.classList.toggle('is-fail', hasFailedRow);
      validationEl.classList.toggle('is-pass', !hasFailedRow);
      renderCompactValidation(validationEl, hasFailedRow);
    } finally {
      setTimeout(function () {
        isDecorating = false;
      }, 0);
    }
  }

  function runWebkulValidation() {
    if (!isWebkulReady()) {
      webkulWaitAttempts += 1;

      if (webkulWaitAttempts <= 20) {
        scheduleRefresh(500);
      } else {
        decorateValidation();
      }

      return;
    }

    webkulWaitAttempts = 0;
    resetWebkulState();
    showLoadingState();

    window.SPL.main_checkout_condition = true;
    window.SPL.minimum_quantity_status = true;

    if (window.SLOT_P) {
      window.SLOT_P.main_checkout_condition = true;
    }

    clearTimeout(failsafeTimer);
    failsafeTimer = setTimeout(decorateValidation, 8000);

    try {
      window.SPL.checkMinimumPurchase(function () {
        clearTimeout(failsafeTimer);
        window.requestAnimationFrame(decorateValidation);
      });
    } catch (error) {
      clearTimeout(failsafeTimer);
      decorateValidation();
      console.error(error);
    }
  }

  function scheduleRefresh(delay) {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(runWebkulValidation, delay || 650);
  }

  function markValidationPending() {
    var validationEl = getValidationEl();

    if (
      validationEl &&
      validationEl.style.display !== 'none' &&
      validationEl.textContent.trim()
    ) {
      validationEl.classList.add('is-refreshing');
    }
  }

  function watchValidationMarkup() {
    var validationEl = getValidationEl();

    if (!validationEl) {
      return;
    }

    new MutationObserver(function () {
      decorateValidation();
    }).observe(validationEl, {
      attributes: true,
      attributeFilter: ['data-fail', 'style'],
      childList: true,
      subtree: true,
    });
  }

  function wrapFetchForCartUpdates() {
    if (fetchWrapped || typeof window.fetch !== 'function') {
      return;
    }

    var originalFetch = window.fetch;
    fetchWrapped = true;

    window.fetch = function () {
      var requestUrl = '';

      try {
        requestUrl =
          typeof arguments[0] === 'string' ? arguments[0] : arguments[0].url || '';
      } catch (error) {
        requestUrl = '';
      }

      var responsePromise = originalFetch.apply(this, arguments);

      if (/\/cart\/(change|update|clear)(\.js)?/.test(requestUrl)) {
        markValidationPending();
        Promise.resolve(responsePromise)
          .then(function () {
            scheduleRefresh(700);
          })
          .catch(function () {
            decorateValidation();
          });
      }

      return responsePromise;
    };
  }

  document.addEventListener(
    'click',
    function (event) {
      if (
        event.target.closest('[data-quantity-plus], [data-quantity-minus], [data-cartitem-remove]')
      ) {
        markValidationPending();
      }
    },
    true
  );

  document.addEventListener(
    'change',
    function (event) {
      if (event.target.matches('[data-quantity-input], .wk_qty_selector')) {
        markValidationPending();
      }
    },
    true
  );

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-checkout-validation-toggle]');

    if (!toggle) {
      return;
    }

    var validationEl = getValidationEl();
    var details = validationEl ? validationEl.querySelector('.cart-checkout-validation__details') : null;
    var expanded = validationEl && !validationEl.classList.contains('is-expanded');

    if (!validationEl || !details) {
      return;
    }

    validationEl.classList.toggle('is-expanded', expanded);
    details.hidden = !expanded;
    toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    toggle.textContent = expanded ? 'Tutup detail' : 'Lihat detail';
  });

  window.addEventListener('cartcount:update', function () {
    scheduleRefresh(650);
  });

  wrapFetchForCartUpdates();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      watchValidationMarkup();
      decorateValidation();
    });
  } else {
    watchValidationMarkup();
    decorateValidation();
  }
})();
